import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

export default function InterviewPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood Collective</p>
        <h1 className="twentytwentysix-content__title">Schedule Your Interview</h1>
        <p className="twentytwentysix-content__copy">
          Joining the Collective starts with a conversation. We want to learn about you and your business, and share how the community can support your growth. The interview is a chance to ask questions and see if the Collective is the right fit.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix/collective" className="twentytwentysix-content__pill">Back to Collective</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <h2 className="twentytwentysix-content__subtitle">What to expect</h2>
          <ul className="twentytwentysix-content__list">
            <li>A short call with our team (about 15–20 minutes)</li>
            <li>Tell us about your business and goals</li>
            <li>Learn about membership benefits and how the community works</li>
            <li>No pressure — we&apos;re here to help you decide if it&apos;s right for you</li>
          </ul>
        </section>

        <section className="twentytwentysix-content__section twentytwentysix-content__section--cream">
          <h2 className="twentytwentysix-content__subtitle">Next steps</h2>
          <p className="twentytwentysix-content__copy">
            Use the contact form on the main site or email us to request an interview. We&apos;ll get back to you within a few business days to schedule a time that works.
          </p>
          <div className="twentytwentysix-content__cta-row">
            <Link to="/twentytwentysix/contact" className="twentytwentysix-content__pill twentytwentysix-content__pill--outline">Contact us</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
